/**
 * The retained-share line.
 *
 * The Terms of Offering say the share GOMPA keeps to operate is shown "on the
 * offering screen before you confirm". This renders that, plainly, from the
 * offering amount and the monastery's platform-fee rate (basis points). It
 * renders nothing when the rate is zero — which is the state until the split
 * is set — so it is safe to place everywhere the amount is shown.
 *
 * Extra support is deliberately not part of this line: it spans the offering,
 * GOMPA and payment processing, and the checkout copy already says so.
 */
import { useTranslation } from 'react-i18next';
import { formatAmount } from '../lib/format';

/** @param {{ offeringCents: number, bps?: number, feeCents?: number, monasteryName: string }} props */
export default function FeeSplit({ offeringCents, bps, feeCents, monasteryName }) {
  const { t } = useTranslation();
  const fee = feeCents != null
    ? feeCents
    : Math.round((offeringCents * (bps ?? 0)) / 10_000);
  if (!offeringCents || fee <= 0) return null;
  const toMonastery = offeringCents - fee;

  return (
    <p className="fee-split subtle">
      {t('checkout.feeSplit', {
        offering: formatAmount(offeringCents),
        monastery: monasteryName,
        toMonastery: formatAmount(toMonastery),
        toGompa: formatAmount(fee),
        defaultValue:
          `Of your ${formatAmount(offeringCents)} offering, ${formatAmount(toMonastery)} goes to ${monasteryName} and ${formatAmount(fee)} operates GOMPA.`,
      })}
    </p>
  );
}
